import { KEY_CHAIN } from "../constants";
import Api from "./api";
import { getCookie } from "./utils";
export default async function fetchUserDetailsFromParamsOrCookie() {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    let userToken = urlParams.get(KEY_CHAIN.ACCESS_TOKEN);

    if (!userToken) {
      userToken = await fetchTokenFromCookie(KEY_CHAIN.REDIRECT);
    }
    
    let userInfo = null;
    let longTokenFetched = null;
    let shortToken = null;
    let osType = null;
    if (userToken && userToken.length > 32) {
      longTokenFetched = userToken;
      document.cookie = `${KEY_CHAIN.SURGERY_TOKEN}=${longTokenFetched};`;
      const resp = await fetchUserDetailsFromLongToken(userToken);
      userInfo = resp.userInfo;
      shortToken = resp.shortToken;
    } else if (userToken && userToken.length === 32) {
      // We dont receive pm entity id from short token. So first fetching the long token and then calling the UserProfile API
      const longToken = await Api.getLongToken({ shortToken: userToken });
      shortToken = userToken;
      longTokenFetched = longToken.encryptedToken;
      document.cookie = `${KEY_CHAIN.SURGERY_TOKEN}=${longToken.encryptedToken};`;
      const resp = await fetchUserDetailsFromLongToken(
        longToken.encryptedToken
      );
      userInfo = resp.userInfo;
    }

    return { userInfo, longToken: longTokenFetched, shortToken, osType };
  } catch (error) {
    return null;
  }
}
const fetchTokenFromCookie = async (name) => {
  try {
    const cookieArray = document.cookie.split(";");
    const cookie = cookieArray.find((item) =>
      item.trim().startsWith(`${name}=`)
    );
    if (!cookie) return null;
    const token = cookie.substring(cookie.indexOf("=") + 1);
    return token || null;
  } catch (error) {
    return null;
  }
};

const fetchUserDetailsFromLongToken = async (token) => {
  try {
    const payload = {
      isSSOLogin: true,
      authServerAccessToken: token,
    };
    const response = await Api.getPMEntityId(payload); // this api fetch user profile data from long token
    if (response && response.user && response.user.userDetails) {
      let shortToken = response.user?.token;
      return { userInfo: response.user.userDetails, shortToken };
    }
    return null;
  } catch (error) {
    return null;
  }
};
